import store from '../../store'

export default function (to, from, next) {
  if (store.getters['User/isLoggedIn'] === false) {
    next({ replace: true, name: 'Login' })
  } else {
    next()
  }
}
